<script>
export default {
  name: 'TwCheckbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    labelSecondary: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    }
  },
  emits: ['update:modelValue']
}
</script>

<template>
  <fieldset class="pl-1">
    <legend v-if="label" class="sr-only font-forms">
      {{ label }}
    </legend>
    <div class="py-1 pl-0">
      <div class="relative flex items-start">
        <div class="flex h-6 items-center">
          <input :id="id" :disabled="readonly" :value="modelValue" :checked="modelValue === true" :aria-describedby="id + '-description'" :name="id" type="checkbox" class="size-5 rounded border-gray-300 text-blue-600 focus:ring-0" @input="$emit('update:modelValue', $event.target.checked)">
        </div>
        <div class="ml-2 text-sm leading-6">
          <label :for="id" class="text-gray-900 font-forms"> <slot> {{ label }} </slot> </label>
          <p v-if="labelSecondary" id="id-description" class="text-gray-500 font-forms">
            {{ labelSecondary }}
          </p>
        </div>
      </div>
    </div>
  </fieldset>
</template>

<style scoped>

</style>
